import { Collapse, Icon, IconButton, List, ListItem, ListItemText } from '@mui/material';
import React, { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {IListItemMenuProps} from 'shared/types/crtlAcess';
import { useTranslation } from 'react-i18next';



export const SidebarItem: React.FC<IListItemMenuProps> = ({ level, title, icon, path, childrens }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const levelInt: number = level as number;

  const { t } = useTranslation();

  const handleClick = () => {
    setOpen((prev) => !prev);
  };
  const [tituloTraduzido, setTituloTraduzido] = useState('');
  useEffect(() => {
    setTituloTraduzido(t('pages.menuSideBar.'+title) || title);
  },[tituloTraduzido]);
  if (childrens) {
    return (
      <React.Fragment>
        <ListItem button onClick={handleClick} >
          <IconButton size='small' color='secondary'>
            {levelInt > 0 && (Array.from(Array(levelInt), (e, i) => {
              return <Icon key={i} />;
            }))}
            <Icon>
              {icon}
            </Icon>
          </IconButton>
          <ListItemText primary={tituloTraduzido}
            primaryTypographyProps={{
              fontSize: 14,
              color: 'secondary',
            }} />
          <Icon color='secondary'>
            {open ? 'expand_less' : 'expand_more'}
          </Icon>
        </ListItem>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {childrens.map((child, key) => (
              <SidebarItem key={key} level={levelInt + 1} title={child.title} icon={child.icon} path={child.path} childrens={child.childrens} />
            ))}
          </List>
        </Collapse>
      </React.Fragment>

    );
  } else {
    return (
      <ListItem button sx={{ paddingY: '0' }}>
        <IconButton size='small' color='secondary'>
          {levelInt > 0 && (Array.from(Array(levelInt), (e, i) => {
            return <Icon key={i} />;
          }))}
          <Icon>
            {icon}
          </Icon>
        </IconButton>
        <ListItemText primary={tituloTraduzido}
          onClick={() => navigate(path ? path : '/')} 
          primaryTypographyProps={{
            fontSize: 14,
            color: 'secondary',
          }} />
      </ListItem>
    );
  }
};